module.exports = __webpack_public_path__ + "img/ic_rib_blanc.56d983c4.svg";